import { useLocation } from 'react-router'
import { useMemo } from 'react'
import qs from 'query-string'

const useGenerateRefLink = () => {
  const location = useLocation()
  // https://jira.nanameue.jp/browse/YAY-5361
  return useMemo(() => {
    try {
      const query = qs.parse(location.search)
      // convert from base64 to string
      const refLink = decodeURIComponent(query.ref as string)

      // allow only yay.onelink.me domain to be a ref link
      if (new URL(refLink).hostname === 'yay.onelink.me') {
        return refLink
      }

      return undefined
    } catch (e) {
      return undefined
    }
  }, [location.search])
}

export default useGenerateRefLink
